<template>
  <div class='widget-W0155V0001'>
    <div>
      <p :class="userProfile === 'employee' || userProfile === 'otp' ? 'info-title-employee' : 'info-title-other'">
        INFO</p>
      <ul v-if="posts && posts.length">
        <li v-for="(post, index) in posts">
          <span v-if="post.institutionsNavn != null && posts.length > 1"
                class="institution-title">{{ post.institutionsNavn }}</span>
          <div v-if="post.institutionsNavn != null || posts.length === 1" class="fixed-info-text">
            <p v-for="(afsnit, pIndex) in post.institutionsInfo.split('\r\n\r\n')" :key="'p-' + pIndex">
                        <span v-for="(linje, lIndex) in afsnit.split('\r\n')" :key="'l-' + lIndex">
                            {{ linje }}
                            <br v-if="lIndex < afsnit.split('\r\n').length - 1"/>
                        </span>
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    axios: Function,
    userProfile: String,
    institutionFilter: Array
  },
  data: function () {
    return {
      posts: []
    }
  },
  created: function () {
    this.axios.get('https://api-info.ibkservices.dk/?institutionsnummer=' + this.institutionFilter + '&userprofile=' + this.userProfile)

      .then(response => {
        this.posts = response.data;
      })
      .catch(e => {
        console.log(e);
      })
  }
}
</script>

<style lang="scss">
.widget-W0155V0001 {
  * {
    background-color: #fff;
  }

  ul {
    margin: 0;
    padding: 12px;
  }

  li {
    list-style: none;
  }

  .fixed-info-text p {
    margin: 0 0 10px 0;
    padding: 0;
  }

  .fixed-info-text p:last-child {
    margin-bottom: 0;
  }

  @media only screen and (max-width: 1399px) {
    .fixed-info-text {
      font-size: 13px !important;
      white-space: normal;
    }

    .institution-title {
      margin-top: 12px;
      text-transform: uppercase;
      font-size: 14px;
      display: inline-block;
      white-space: normal;
    }
  }

  @media only screen and (min-width: 1400px) {
    .fixed-info-text {
      font-size: 16px !important;
      white-space: normal;
    }

    .institution-title {
      margin-top: 12px;
      text-transform: uppercase;
      font-size: 16px;
      display: inline-block;
      white-space: normal;
    }
  }

  li:first-child .institution-title {
    margin-top: 2px !important;
  }

  .info-title-employee {
    font-family: Lato, sans-serif;
    background-color: #007a8d;
    font-size: 18px;
    padding: 12px !important;
    margin-bottom: 0 !important;
    color: #fff;
    display: block;
    text-transform: uppercase;
  }

  .info-title-other {
    font-family: Lato, sans-serif;
    background-color: #18638f;
    font-size: 18px;
    padding: 12px !important;
    margin-bottom: 0 !important;
    color: #fff;
    display: block;
    text-transform: uppercase;
  }
}
</style>
